type IMarginKey =
  | "marginMedium"
  | "marginBase"
  | "marginLarge"
  | "marginBig"
  | "paddingPage"
  | "paddingMedium"
  | "paddingPageXBig"
  | "paddingPageBig";

const margins: { [key in IMarginKey]: string } = {
  marginBase: "16px",
  marginBig: "24px",
  marginLarge: "32px",
  marginMedium: "8px",
  paddingMedium: "8px",
  paddingPage: "16px",
  paddingPageBig: "24px",
  paddingPageXBig: "32px",
};

export default margins;
